import moment from "moment/moment";
/**
 * 监测数据
 * 最新cimiss数据
 */
import request from "@/utils/request";
// import { redefineStationInfo } from './stations_utils'
import { redefineStationInfo } from "@/utils/stations_utils";
const list = (areaCode: string, staLevels: string = "") => {
  const params: any = {
    adminCodes: areaCode,
  };
  if (staLevels && staLevels !== "") {
    params.staLevels = staLevels;
  }
  const reuslt = request.get("/cw/surface_data/list/surf_hour_data", params);
  return reuslt;
};

const stationData = (
  staIds: string,
  adminCodes: string,
  timeRange: string,
  times: string,
  elements: string,
  dataCode?: string
) => {
  const params: any = {
    elements,
  };
  if (staIds && staIds != "") {
    params.staIds = staIds;
  } else {
    params.adminCodes = adminCodes;
  }
  let getDataCode = "";
 
  if (dataCode && dataCode !== "") {
    getDataCode = dataCode;
  } else {
    getDataCode = "surf_hour_data";
  }
  console.log(getDataCode)
  if (timeRange && timeRange !== "") {
    params.timeRange = timeRange;
  } else {
    if (times && times !== "") {
      params.times = times;
    } else {
      let getTimes = "";
      if ((getDataCode === "surf_min_data")) {
        const mm = moment(new Date(), "YYYYMMDDHHmmss").format("mm");
        const num = Number(mm) % 5;
        if (num > 0) {
          getTimes = moment(new Date(), "YYYYMMDDHHmmss")
            .subtract(num, "minutes")
            .subtract(8, "hours")
            .format("YYYYMMDDHHmm00");
        } else if (num === 0) {
          getTimes = moment(new Date(), "YYYYMMDDHHmmss")
            .subtract(5, "minutes")
            .subtract(8, "hours")
            .format("YYYYMMDDHHmm00");
        }
        params.times = getTimes;
      } else {
        params.times = moment(new Date(), "YYYYMMDDHH0000").subtract(
          8,
          "hours"
        )  .format("YYYYMMDDHH0000");;
      }
    }
  }
    console.log(getDataCode)
  return request.get("/cw/surface_data/list/" + getDataCode, params);
};

const stationStatData = (
  staIds: string,
  adminCodes: string,
  timeRange: string,
  times: string,
  elements: string
) => {
  const params: any = {
    elements,
  };
  if (staIds && staIds != "") {
    params.staIds = staIds;
  } else {
    params.adminCodes = adminCodes;
  }
  if (timeRange && timeRange !== "") {
    params.timeRange = timeRange;
  }
  if (times && times !== "") {
    params.times = times;
  }
  return request.get("/cw/surface_stat/list/surf_hour_data", params);
};

const stationList = (areaCode: string, staLevels: string = "") => {
  const params: any = {
    adminCodes: areaCode,
  };
  if (staLevels && staLevels !== "") {
    params.staLevels = staLevels;
  }
  return request.get("/cw/station_info/list", params);
};

const warningSignalList = (areaCode: string) => {
  const params = {
      areaIds: areaCode,
  }
  return request.get('/wm_rest_app/warn_info/list', params)


};

export default {
  list,
  stationList,
  warningSignalList,
  stationData,
  stationStatData,
};
